import { render, staticRenderFns } from "./Scratchcard.vue?vue&type=template&id=299b017e&scoped=true&"
import script from "./Scratchcard.vue?vue&type=script&lang=js&"
export * from "./Scratchcard.vue?vue&type=script&lang=js&"
import style0 from "./Scratchcard.vue?vue&type=style&index=0&id=299b017e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b017e",
  null
  
)

export default component.exports